import { LegalLayout, Clause, Bi, BiList, ORG_NAME } from "./LegalLayout";

export default function RefundPolicyPage() {
  return (
    <LegalLayout
      title="Refund and Cancellation Policy"
      titleBn="ফেরত ও বাতিলকরণ নীতিমালা"
      intro={
        <Bi
          en={
            <>
              This Refund and Cancellation Policy applies to all online courses, live classes,
              mock tests and other digital learning services purchased from {ORG_NAME}{" "}
              (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;, the &ldquo;Platform&rdquo;).
              Because our products are digital educational services delivered instantly, refunds
              are limited to the specific cases described below. Please read this policy carefully
              before making a purchase.
            </>
          }
          bn={
            <>
              এই ফেরত ও বাতিলকরণ নীতিমালা {ORG_NAME} থেকে ক্রয়কৃত সকল অনলাইন কোর্স, লাইভ ক্লাস,
              মক টেস্ট এবং অন্যান্য ডিজিটাল শিক্ষা-সেবার ক্ষেত্রে প্রযোজ্য। আমাদের পণ্যসমূহ তাৎক্ষণিকভাবে
              সরবরাহকৃত ডিজিটাল শিক্ষা-সেবা হওয়ায়, ফেরত কেবল নিচে বর্ণিত নির্দিষ্ট ক্ষেত্রেই সীমাবদ্ধ।
              ক্রয়ের পূর্বে অনুগ্রহ করে এই নীতিমালা মনোযোগ দিয়ে পড়ুন।
            </>
          }
        />
      }
    >
      <Clause n="1" title="Refund Request Window & Eligibility" titleBn="ফেরত আবেদনের সময়সীমা ও যোগ্যতা">
        <Bi
          en={
            <>
              A refund request must be submitted within <strong>seven (7) calendar days</strong> of
              the purchase date. To be eligible for consideration, the student must have accessed
              <strong> less than 20%</strong> of the purchased course content.
            </>
          }
          bn={
            <>
              ক্রয়ের তারিখ থেকে <strong>সর্বোচ্চ ৭ (সাত) ক্যালেন্ডার দিনের</strong> মধ্যে ফেরত আবেদন করতে হবে।
              বিবেচনার যোগ্য হতে হলে শিক্ষার্থীকে ক্রয়কৃত কোর্সের <strong>২০ শতাংশের কম</strong> কনটেন্ট
              দেখে থাকতে হবে।
            </>
          }
        />
      </Clause>

      <Clause n="2" title="When a Full Refund Applies" titleBn="যেসব ক্ষেত্রে সম্পূর্ণ ফেরত প্রযোজ্য">
        <Bi
          en={<>A full refund of the amount actually paid will be issued in the following cases:</>}
          bn={<>নিম্নোক্ত ক্ষেত্রে প্রকৃত পরিশোধিত অর্থের সম্পূর্ণ ফেরত প্রদান করা হবে:</>}
        />
        <BiList
          items={[
            ["Duplicate payment for the same product.", "একই পণ্যের জন্য দ্বৈত (ডুপ্লিকেট) পেমেন্ট হলে।"],
            [
              "Course access is not delivered within 24 hours of a successful payment.",
              "সফল পেমেন্টের পর ২৪ ঘণ্টার মধ্যে কোর্স অ্যাক্সেস না পাওয়া গেলে।",
            ],
            [
              "The course or batch is cancelled by us before it begins.",
              "কোর্স বা ব্যাচ শুরুর পূর্বে আমাদের পক্ষ থেকে বাতিল করা হলে।",
            ],
            [
              "A serious technical fault on our side prevents use of the service and cannot be resolved within a reasonable time.",
              "আমাদের পক্ষের গুরুতর কারিগরি ত্রুটির কারণে সেবা ব্যবহার করা সম্ভব না হলে এবং যুক্তিসংগত সময়ের মধ্যে তা সমাধান করা না গেলে।",
            ],
            [
              "The core service promised in the course description or advertisement is not provided.",
              "কোর্স বিবরণে বা বিজ্ঞাপনে প্রতিশ্রুত মূল সেবা প্রদান করা না হলে।",
            ],
          ]}
        />
        <Bi
          en={
            <>
              In line with the Digital Commerce Operation Guidelines, 2021, where we are unable to
              deliver a paid service due to an unforeseen circumstance, we will inform you within
              48 hours and issue the applicable refund within the following 72 hours.
            </>
          }
          bn={
            <>
              ডিজিটাল কমার্স অপারেশন গাইডলাইনস, ২০২১ অনুযায়ী, কোনো অপ্রত্যাশিত পরিস্থিতির কারণে পরিশোধিত সেবা
              সরবরাহ করা সম্ভব না হলে আমরা ৪৮ ঘণ্টার মধ্যে আপনাকে অবহিত করব এবং পরবর্তী ৭২ ঘণ্টার মধ্যে
              প্রযোজ্য ফেরত প্রদান করব।
            </>
          }
        />
      </Clause>

      <Clause n="3" title="When Refunds Are Not Allowed" titleBn="যেসব ক্ষেত্রে ফেরত প্রযোজ্য নয়">
        <Bi
          en={<>Refunds will generally not be granted in the following cases:</>}
          bn={<>সাধারণত নিম্নোক্ত ক্ষেত্রে ফেরত প্রদান করা হবে না:</>}
        />
        <BiList
          items={[
            ["20% or more of the course content has been accessed.", "কোর্সের ২০ শতাংশ বা তার বেশি কনটেন্ট দেখা হলে।"],
            [
              "Any PDF, note, recording or downloadable resource has been downloaded.",
              "কোনো পিডিএফ, নোট, রেকর্ডিং বা ডাউনলোডযোগ্য রিসোর্স ডাউনলোড করা হলে।",
            ],
            [
              "A mock test or quiz has been attempted (attempted mock tests are non-refundable).",
              "কোনো মক টেস্ট বা কুইজ দেওয়া হলে (দেওয়া মক টেস্ট ফেরতযোগ্য নয়)।",
            ],
            ["A certificate has been issued.", "সার্টিফিকেট ইস্যু করা হলে।"],
            [
              "A live class, consultation or personal support session has been attended.",
              "লাইভ ক্লাস, পরামর্শ বা ব্যক্তিগত সহায়তা সেশন গ্রহণ করা হলে।",
            ],
            ["The 7-day refund request window has expired.", "৭ দিনের ফেরত আবেদনের সময়সীমা শেষ হয়ে গেলে।"],
            [
              "The account has been suspended or terminated for violating our Terms & Conditions (including piracy, content sharing or exam misconduct).",
              "আমাদের শর্তাবলি লঙ্ঘনের (পাইরেসি, কনটেন্ট শেয়ারিং বা পরীক্ষায় অসদাচরণসহ) কারণে অ্যাকাউন্ট স্থগিত বা বাতিল করা হলে।",
            ],
            [
              "The request is based only on a change of mind, lack of time, or inability to complete the course.",
              "শুধুমাত্র মত পরিবর্তন, সময়ের অভাব বা কোর্স সম্পন্ন করতে না পারার কারণে আবেদন করা হলে।",
            ],
          ]}
        />
      </Clause>

      <Clause n="4" title="How to Request a Refund" titleBn="ফেরতের আবেদন প্রক্রিয়া">
        <Bi
          en={
            <>
              To request a refund, contact us using the details at the bottom of this page and
              include the following information:
            </>
          }
          bn={
            <>
              ফেরতের জন্য এই পৃষ্ঠার নিচে দেওয়া তথ্য ব্যবহার করে আমাদের সাথে যোগাযোগ করুন এবং নিম্নোক্ত
              তথ্যসমূহ প্রদান করুন:
            </>
          }
        />
        <BiList
          items={[
            ["Full name of the student", "শিক্ষার্থীর পূর্ণ নাম"],
            ["Registered mobile number and email", "নিবন্ধিত মোবাইল নম্বর ও ইমেইল"],
            ["Course or product name", "কোর্স বা পণ্যের নাম"],
            ["Amount paid and payment date", "পরিশোধিত পরিমাণ ও পেমেন্টের তারিখ"],
            ["bKash Transaction ID (TrxID)", "বিকাশ ট্রানজেকশন আইডি (TrxID)"],
            ["Reason for the refund request", "ফেরত চাওয়ার কারণ"],
          ]}
        />
        <Bi
          en={<>Incomplete information may delay the processing of your request.</>}
          bn={<>অসম্পূর্ণ তথ্য প্রদান করলে আবেদন প্রক্রিয়াকরণে বিলম্ব হতে পারে।</>}
        />
      </Clause>

      <Clause n="5" title="Review & Processing Time" titleBn="পর্যালোচনা ও প্রক্রিয়াকরণের সময়">
        <Bi
          en={
            <>
              We will acknowledge receipt of a refund request within <strong>two (2) business days</strong>.
              Each request is reviewed manually against this policy. Where a refund is approved, we
              will make our best effort to return the amount to the original bKash account used for
              payment within <strong>7–10 business days</strong> of approval.
            </>
          }
          bn={
            <>
              আমরা <strong>২ (দুই) কার্যদিবসের</strong> মধ্যে ফেরত আবেদন গ্রহণের বিষয়টি নিশ্চিত করব। প্রতিটি
              আবেদন এই নীতিমালার আলোকে ম্যানুয়ালি পর্যালোচনা করা হয়। অনুমোদিত হলে, অনুমোদনের{" "}
              <strong>৭–১০ কার্যদিবসের</strong> মধ্যে পেমেন্টে ব্যবহৃত মূল বিকাশ অ্যাকাউন্টে অর্থ ফেরত দেওয়ার
              সর্বাত্মক চেষ্টা করা হবে।
            </>
          }
        />
      </Clause>

      <Clause n="6" title="Payment Gateway (bKash) Conditions" titleBn="পেমেন্ট গেটওয়ে (বিকাশ) শর্তাবলি">
        <BiList
          items={[
            [
              "All refunds are processed only to the original bKash account and transaction used for the purchase.",
              "সকল ফেরত কেবল ক্রয়ে ব্যবহৃত মূল বিকাশ অ্যাকাউন্ট ও লেনদেনেই প্রক্রিয়া করা হয়।",
            ],
            [
              "Only the amount actually received by us (after any coupon or discount) is refundable. Any coupon used on the purchase is released back to your account.",
              "কেবল আমাদের প্রকৃতপক্ষে প্রাপ্ত অর্থ (কুপন বা ছাড় প্রয়োগের পর) ফেরতযোগ্য। ক্রয়ে ব্যবহৃত কুপন আপনার অ্যাকাউন্টে পুনরায় যুক্ত করা হয়।",
            ],
            [
              "Bank, mobile financial service or gateway processing times may add additional days beyond our control.",
              "ব্যাংক, মোবাইল আর্থিক সেবা বা গেটওয়ের প্রক্রিয়াকরণ সময়ের কারণে আমাদের নিয়ন্ত্রণের বাইরে অতিরিক্ত সময় লাগতে পারে।",
            ],
            [
              "Any gateway or transaction fee charged by the payment provider is non-refundable where permitted by the provider's rules.",
              "পেমেন্ট প্রদানকারীর নিয়ম অনুযায়ী প্রযোজ্য ক্ষেত্রে গেটওয়ে বা লেনদেন ফি অ-ফেরতযোগ্য।",
            ],
          ]}
        />
      </Clause>

      <Clause n="7" title="Digital Access After a Refund" titleBn="ফেরতের পর ডিজিটাল অ্যাক্সেস">
        <Bi
          en={
            <>
              Once a refund is approved and processed, your access to the refunded course, mock test
              or digital product is <strong>immediately and permanently revoked</strong>. You must
              stop using, and delete any copies of, all related materials. Continued use of content
              after a refund is a breach of these terms and of our intellectual property rights.
            </>
          }
          bn={
            <>
              ফেরত অনুমোদিত ও প্রক্রিয়াকৃত হওয়ার সাথে সাথে সংশ্লিষ্ট কোর্স, মক টেস্ট বা ডিজিটাল পণ্যে আপনার
              অ্যাক্সেস <strong>তাৎক্ষণিকভাবে ও স্থায়ীভাবে বাতিল</strong> করা হবে। আপনাকে সংশ্লিষ্ট সকল উপকরণের
              ব্যবহার বন্ধ করতে হবে এবং যেকোনো কপি মুছে ফেলতে হবে। ফেরতের পর কনটেন্ট ব্যবহার অব্যাহত রাখা এই
              শর্তাবলি ও আমাদের মেধাস্বত্ব অধিকারের লঙ্ঘন।
            </>
          }
        />
      </Clause>

      <Clause n="8" title="Course Transfer as an Alternative" titleBn="বিকল্প হিসেবে কোর্স স্থানান্তর">
        <Bi
          en={
            <>
              In place of an eligible refund, and by mutual agreement, a student may request a
              transfer to another course of equal value or enrolment in a future batch.
            </>
          }
          bn={
            <>
              যোগ্য ফেরতের পরিবর্তে, উভয় পক্ষের সম্মতিতে, শিক্ষার্থী সমমূল্যের অন্য কোর্সে স্থানান্তর বা
              ভবিষ্যৎ ব্যাচে ভর্তির আবেদন করতে পারবেন।
            </>
          }
        />
      </Clause>

      <Clause n="9" title="Changes & Governing Law" titleBn="পরিবর্তন ও প্রযোজ্য আইন">
        <Bi
          en={
            <>
              We may update this policy from time to time; the version in effect at the time of your
              purchase applies to that purchase. This policy is governed by the applicable laws of
              Bangladesh, including the Consumer Rights Protection Act, 2009 and the Digital Commerce
              Operation Guidelines, 2021. Nothing in this policy limits any statutory right you may
              have as a consumer.
            </>
          }
          bn={
            <>
              আমরা সময়ে সময়ে এই নীতিমালা হালনাগাদ করতে পারি; ক্রয়ের সময় বলবৎ সংস্করণটি সেই ক্রয়ের ক্ষেত্রে
              প্রযোজ্য হবে। এই নীতিমালা বাংলাদেশের প্রযোজ্য আইন, বিশেষত ভোক্তা-অধিকার সংরক্ষণ আইন, ২০০৯ এবং
              ডিজিটাল কমার্স অপারেশন গাইডলাইনস, ২০২১ দ্বারা পরিচালিত হবে। এই নীতিমালার কোনো কিছুই ভোক্তা হিসেবে
              আপনার আইনগত অধিকার সীমিত করবে না।
            </>
          }
        />
      </Clause>
    </LegalLayout>
  );
}
